<template>
  <transition name="fade-in">
    <a v-if="isVisible" :href="affiliateLink" target="_blank" rel="nofollow noopener" class="banner-container">
      <button class="close-button" @click.stop.prevent="hideBanner">✕</button>

      <div class="banner-content">
        <img src="../../assets/rank-table/vendor-1.png" alt="給湯器駆けつけ隊" class="banner-img" />
        <div class="text-boxes">
          <div class="info-box last-info-box">
            <p class="price-text">最大91%OFF・即日対応OK</p>
          </div>
          <div class="info-box">
            <p class="vendor-name">給湯器駆けつけ隊</p>
            <p class="no1-text">申込者数当サイト圧倒的No.1!!</p>
          </div>
        </div>
      </div>
    </a>
  </transition>
</template>


<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";
import { makeAffiliateUrl } from '@/utils/aff.js'

const isVisible = ref(false);
let hasBeenClosedThisSession = ref(false);
const affiliateLink = computed(() => makeAffiliateUrl())

const displayThreshold = 17000;

const handleScroll = () => {
  if (hasBeenClosedThisSession.value) return;
  if (window.scrollY > displayThreshold && !isVisible.value) {
    isVisible.value = true;
  }
};

const hideBanner = () => {
  isVisible.value = false;
  hasBeenClosedThisSession.value = true;
};

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});
onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>

<style scoped>
.fade-in-enter-from,
.fade-in-leave-to {
  opacity: 0;
}

.fade-in-enter-active,
.fade-in-leave-active {
  transition: opacity 0.5s ease-in-out;
}

.banner-container {
  background-color: #008080;
  padding: 15px;
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  max-width: 580px;
  z-index: 1000;
  box-sizing: border-box;
  text-decoration: none;
}

.close-button {
  position: absolute;
  top: 1px;
  right: 1px;
  background-color: #333;
  color: white;
  border: none;
  border-radius: 50%;
  width: 26px;
  height: 26px;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 1001;
}

.banner-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
}

.banner-img {
  width: 30%;
  height: auto;
  flex-shrink: 0;
  border-radius: 4px;
  background: #fff;
  padding: 4px;
}

.text-boxes {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}

.info-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #1a7e7e;
  border: 2px solid #ffcc00;
  padding: 8px 12px;
  color: white;
  border-radius: 4px;
}

.last-info-box {
  background-color: white;
  color: #333;
  border: 2px solid #ffcc00;
  padding: 8px 12px;
  border-radius: 4px;
  text-align: center;
}

.vendor-name {
  font-size: 25px;
  font-weight: bold;
  margin: 0 0 4px;
  color: #ffeb3b;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.6);
}

.label {
  font-size: 12px;
  margin: 0;
  opacity: 0.8;
}

.no1-text {
  font-size: 18px;
  font-weight: bold;
  margin: 4px 0 0;
  text-align: center;
  color: #fff;
}

.price-text {
  font-size: 14px;
  font-weight: bold;
  margin: 0;
  line-height: 1.4;
  color: #d9534f;
}

@media (max-width: 600px) {
  .banner-container {
    width: 100%;
  }

  .price-text {
    font-size: 0.9rem;
  }

  .vendor-name {
    font-size: 1.2rem;
  }

  .no1-text {
    font-size: 0.9rem;
    margin: 0;
    padding: 0;
  }

  .close-button {
    width: 30px;
    height: 30px;
    top: -14px;
    right: -5px;
    font-weight: bold;
    font-size: 1.5rem;
  }

  .vendor-name {
    margin: 0;
    padding: 0;
  }
}

@media (max-width: 480px) {
  .price-text {
    font-size: 0.8rem;
  }

  .vendor-name {
    font-size: 1.1rem;
  }

  .no1-text {
    font-size: 0.8rem;
    margin: 0;
    padding: 0;
  }

  .close-button {
    width: 30px;
    height: 30px;
    top: -14px;
    right: -5px;
    font-weight: bold;
    font-size: 1.5rem;
  }

  .vendor-name {
    margin: 0;
    padding: 0;
  }

  .info-box {
    padding: 5px;
  }
}
</style>
